import { render, staticRenderFns } from "./FloorFormAdd.vue?vue&type=template&id=c0ff06ce&"
import script from "./FloorFormAdd.vue?vue&type=script&lang=js&"
export * from "./FloorFormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports